export const PICKER_MODE = {
  Date: 'date',
  Week: 'week',
  Month: 'month',
  Quarter: 'quarter',
  Year: 'year',
} as const;

export const PICKER_MODES = Object.values(PICKER_MODE);
